import * as React from 'react';
import { Form, FormProps, actions } from 'react-redux-form';
import { ReactNode } from 'react-redux';
import { store } from '../../..';

export interface FormWrapperProperties extends FormProps {
  readonly shouldFormReset?: boolean;
  readonly children: ReactNode;
  readonly target?: string;
}

export class FormWrapper extends React.Component<FormWrapperProperties> {
  componentWillUnmount() {
    if (this.props.shouldFormReset) {
      store.dispatch(actions.reset(this.props.model));
    }
  }

  render() {
    let passProps = {
      ...this.props
    };
    delete passProps.shouldFormReset;
    return (
      <div>
        <Form {...passProps}>{this.props.children}</Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/form-wrapper/form-wrapper.component.tsx